import styled from 'styled-components';
import { withTracker } from '@/tracker';
import getMarkdownPaths from '@/ssr-props-getters/get-markdown-paths';
import getMarkdownContent from '@/ssr-props-getters/get-markdown-content';

import Section from '@/components/section';
import TitleBase from '@/components/title';
import BackLink from '@/components/back-link';
import SEO from '@/components/seo';

const Title = styled(TitleBase)`
  color: ${props => props.theme.colors.brand.primary};
  margin: 0 0 .125em;
`;

const Date = styled.small`
  color: ${props => props.theme.colors.typography.subtle};
  display: block;
  margin-bottom: 3em;
`;

const Content = styled.div`
  line-height: 1.2;

  h2 {
    font-size: min(max(1.5em, 6vw), 2em);
  }

  h3 {
    font-size: min(max(1.125em, 5.25vw), 1.5em);
  }

  p, li {
    font-size: min(max(.9em, 4vw), 1em);
  }

  ul > li, li + li {
    margin-top: 1em;
  }
`;

const Policy = ({ content, date, description, keywords, title }) => {
  return (
    <>
      <SEO title={title} description={description} keywords={keywords} />
      <Section>
        <BackLink href="/policies/" title="All Bidali policies & procedures">
          View All Policies
        </BackLink>
        <Title>{title}</Title>
        <Date>Last updated on {date}</Date>
        <Content dangerouslySetInnerHTML={{ __html: content }} />
      </Section>
    </>
  );
};

export default withTracker(Policy);

export async function getStaticPaths () {
  return getMarkdownPaths('policies');
}

export async function getStaticProps (context) {
  return getMarkdownContent(context, 'policies');
}
